import { render, staticRenderFns } from "./hero-filter-only-layout.vue?vue&type=template&id=7f8b90d2"
import script from "./hero-filter-only-layout.vue?vue&type=script&lang=js"
export * from "./hero-filter-only-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports